import { createReducer, on } from '@ngrx/store';
import {
  DecrementActionRequests,
  DecrementLoadRequests,
  DecrementSearchRequests,
  IncrementActionRequests,
  IncrementLoadRequests,
  IncrementSearchRequests,
  SetLoadingBar,
  SetLoadingSpinner,
  SetSearchSpinner,
} from '../actions/progress.actions';

export interface ProgressState {
  totalLoadRequests: number;
  totalActionRequests: number;
  totalSearchRequests: number;
  showSpinner: boolean;
  showBar: boolean;
  showSearchSpinner: boolean;
}

const initialState: ProgressState = {
  totalLoadRequests: 0,
  totalActionRequests: 0,
  totalSearchRequests: 0,
  showSpinner: false,
  showBar: false,
  showSearchSpinner: false,
};

export const ProgressReducer = createReducer(
  initialState,
  on(SetLoadingSpinner, (state, { showSpinner }) => ({
    ...state,
    showSpinner,
  })),
  on(SetLoadingBar, (state, { showBar }) => ({
    ...state,
    showBar,
  })),
  on(SetSearchSpinner, (state, { showSearchSpinner }) => ({
    ...state,
    showSearchSpinner,
  })),
  on(IncrementLoadRequests, (state) => ({
    ...state,
    totalLoadRequests: state.totalLoadRequests + 1,
  })),
  on(IncrementActionRequests, (state) => ({
    ...state,
    totalActionRequests: state.totalActionRequests + 1,
  })),
  on(IncrementSearchRequests, (state) => ({
    ...state,
    totalSearchRequests: state.totalSearchRequests + 1,
  })),
  on(DecrementLoadRequests, (state) => ({
    ...state,
    totalLoadRequests: state.totalLoadRequests - 1,
  })),
  on(DecrementActionRequests, (state) => ({
    ...state,
    totalActionRequests: state.totalActionRequests - 1,
  })),
  on(DecrementSearchRequests, (state) => ({
    ...state,
    totalSearchRequests: state.totalSearchRequests - 1,
  })),
);
